import { render, staticRenderFns } from "./ConfirmRedirect.vue?vue&type=template&id=7c6f44b2&scoped=true&"
import script from "./ConfirmRedirect.vue?vue&type=script&lang=js&"
export * from "./ConfirmRedirect.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRedirect.vue?vue&type=style&index=0&id=7c6f44b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6f44b2",
  null
  
)

export default component.exports